import { carType } from "../../api/Cars/type/CarsType"

//mui
import StarIcon from '@mui/icons-material/Star';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import WeekendOutlinedIcon from '@mui/icons-material/WeekendOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';


//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";

//image
import placeHoldercar from "../../assets/home/placeholder.png"

interface popularCarProps {
    element: carType
}
const storageURL = process.env.REACT_APP_STORAGE_BASE_URL

const PopularCar = ({element}:popularCarProps) => {
  const {t} = useTranslation()

  return (
    <div className="rounded-[15px] flex gap-3 max-lg:flex-col items-center border-[1px] border-solid border-darkColor cursor-pointer overflow-hidden">
      <div className="w-1/2 h-[142px] max-lg:w-full">
          <img className=' h-full lg:m-auto w-full max-lg:h-[150px] object-cover' 
          src={`${element.primary_images.length !== 0 ? storageURL + "/" + element.primary_images[0].url : placeHoldercar}`} alt="no_photo"/>
      </div>
      <div className="py-5 m-0 box-border max-lg:px-3 mt-3 w-1/2 max-lg:w-full">
        <p className="font-[600]">{element.brand.name}</p>
        <div className="text-[#7F7F7F] text-sm">
          <div className="flex items-center gap-2 mt-2">
            <StarIcon  className="!text-[#FF8F3A]"/>
            <p>5.0</p>
          </div>
          <div>
            {
              element.is_daily !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.daily_price))}  / {t("day")}</p>
                </div>
              :
              element.is_weekly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.weekly_price))} / {t("week")}</p>
                </div>
              :
              element.is_monthly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.monthly_price))} / {t("month")}</p>
                </div>
              :
              <></>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopularCar